import { ComponentProps } from "@declarations/props";
import { Button, Modal } from "antd";
import { useEffect, useRef, useState } from "react";

export const PopupConfirm: ComponentProps<{
  open: boolean;
  title: string;
  message: string;
  textConfirm?: string;
  textCancel: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}> = ({
  open,
  title,
  message,
  textConfirm = "Ya",
  textCancel = "Batalkan",
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  return (
    <>
      <Modal
        className="tw-text-center"
        title={title}
        open={open}
        onCancel={onCancel}
        closable={false}
        centered
        footer={[
          <Button
            key="back"
            className="tw-mt-4 tw-m-1"
            style={{ width: "47%" }}
            onClick={onCancel}
          >
            {textCancel}
          </Button>,
          <Button
            key="submit"
            className="tw-mt-4 tw-m-1 tw-text-white bg-gradient"
            style={{ width: "47%" }}
            onClick={onConfirm}
          >
            {textConfirm}
          </Button>,
        ]}
      >
        <div className="tw-text-sm tw-text-text-secondary">{message}</div>
      </Modal>
    </>
  );
};

export const PopupCustom: ComponentProps<{
  open: boolean;
  title: string;
  className?: string;
  wrapClassName?: string;
  transitionName?: string;
  maskTransitionName?: string;
  centered?: boolean;
  slideUpModal?: boolean;
  closable?: boolean;
  onCancel?: () => void;
  onClose?: () => void;
}> = ({ open, title, onCancel = () => {}, slideUpModal, children }) => {
  const [visible, setVisible] = useState(open);
  const [closing, setClosing] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleInternalClose = () => {
    setClosing(true);
    timeoutRef.current = setTimeout(() => {
      setClosing(false);
      setVisible(false);
      onCancel();
    }, 200); // match the slide-down duration
  };

  useEffect(() => {
    if (open) {
      setVisible(true);
    } else {
      handleInternalClose();
    }
  }, [open]);

  if (slideUpModal) {
    return (
      <>
        <Modal
          title={title}
          open={visible}
          onCancel={handleInternalClose}
          closable={false}
          footer={null}
          centered={false}
          transitionName=""
          maskTransitionName=""
          modalRender={(modal) => (
            <div
              className={`tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-z-50 tw-animate-slide-up tw-rounded-t-2xl tw-bg-background-200 ${
                closing ? "tw-animate-slide-down" : "tw-animate-slide-up"
              }`}
            >
              <div className="tw-py-4 tw-w-full">{modal}</div>
            </div>
          )}
        >
          <div className="tw-text-sm tw-text-accent-primary">{children}</div>
        </Modal>
      </>
    );
  }
  return (
    <>
      <Modal
        title={title}
        open={open}
        onCancel={onCancel}
        closable={false}
        footer={null}
        centered={true}
      >
        <div className="tw-text-sm tw-text-accent-primary">{children}</div>
      </Modal>
    </>
  );
};

export const PopupSuccess: ComponentProps<{
  open: boolean;
  title: string;
  message: string;
  textConfirm: string;
  onConfirm?: () => void;
}> = ({ open, title, message, textConfirm, onConfirm = () => {} }) => {
  return (
    <>
      <Modal
        className="tw-text-center"
        title={title}
        open={open}
        closable={false}
        centered
        footer={[
          <Button
            key="back"
            className="tw-mt-4 tw-m-1 tw-text-white bg-gradient"
            style={{ width: "100%" }}
            onClick={onConfirm}
          >
            {textConfirm}
          </Button>,
        ]}
      >
        <div className="tw-text-sm tw-text-text-secondary">{message}</div>
      </Modal>
    </>
  );
};

export const PopupError: ComponentProps<{
  open: boolean;
  title: string;
  message: string;
  textConfirm: string;
  onConfirm?: () => void;
}> = ({ open, title, message, textConfirm, onConfirm = () => {} }) => {
  return (
    <>
      <Modal
        className="tw-text-center"
        title={title}
        open={open}
        closable={false}
        centered
        footer={[
          <Button
            key="back"
            className="tw-mt-4 tw-m-1 tw-text-white tw-bg-red-500"
            style={{ width: "100%" }}
            onClick={onConfirm}
          >
            {textConfirm}
          </Button>,
        ]}
      >
        <div className="tw-text-sm tw-text-text-secondary">{message}</div>
      </Modal>
    </>
  );
};
